"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ReadinessCheck = require("./ReadinessCheck.styled");
var _default = exports["default"] = function _default() {
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheck.StyledAudio, null);
};